import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { isNil } from 'ramda';
import ReactMarkdown from 'react-markdown';
import currencyFormatter from 'currency-formatter';
import { MdMailOutline } from 'react-icons/md';
import { test } from 'ramda';
import ReactPixel from 'react-facebook-pixel';

import BoardgameHeader from './BoardgameHeader';
import Page from './Page';
import Error from './Error';

import placeIcon from '../assets/images/icon-plane.svg';

class SecondHandBoardgamePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requested: false,
    };

    this.notFound = this.notFound.bind(this);
    this.pageTitle = this.pageTitle.bind(this);
  }

  componentWillMount() {
    this.props.changeHeaderType('transparent');
  }

  componentDidMount() {
    ReactPixel.pageView();

    if (!this.state.requested && !this.props.boardgame) {
      this.props.getBoardgame(this.props.match.params.id);
      this.setState({ requested: true });
    }
  }

  componentWillUnmount() {
    this.props.changeHeaderType('default');
  }

  notFound() {
    return !this.props.loading && this.state.requested && isNil(this.props.boardgame);
  }

  pageTitle() {
    let partialTitle;
    if (this.props.loading) {
      partialTitle = 'Caricamento...';
    } else if (this.notFound()) {
      partialTitle = 'Non trovato';
    } else {
      partialTitle = this.props.boardgame && this.props.boardgame.title;
    }

    return `${partialTitle} - Smart Gaming Replay`;
  }


  render() {
    if (this.notFound()) {
      this.props.changeHeaderType('default');
      return (
        <Error
          title="Non abbiamo trovato il gioco che hai chiesto..."
          message="Forse ti sei perso mentre sfogliavi i regolamenti dei tuoi nuovi giochi."
          redirectTo="/replay"
          icon={placeIcon} />
      );
    }

    const headerComponent = () =>
      <BoardgameHeader
        title={this.props.boardgame.title}
        imageUrl={this.props.boardgame.image}
        backgroundPosition="center center" />;

    return (
      <React.Fragment>
        <Helmet>
          <title>{ this.pageTitle() }</title>
        </Helmet>
        { 
          this.props.boardgame && 
            <Page heroComponent={headerComponent} paddingTop={false}>
              <main className="sg-boardgame-page py-4 px-4 md:px-8">
                <ul>
                  <li><span className="font-bold uppercase">Edizione: </span>{ this.props.boardgame.edition }</li>
                  <li><span className="font-bold uppercase">Lingua: </span>{ this.props.boardgame.language }</li>
                  {
                    !test(/itali/i, this.props.boardgame.language) &&
                      <li><span className="font-bold uppercase">Dipendenza dalla lingua: </span>{ this.props.boardgame.languageDependant ? 'Sì' : 'No' }</li>
                  }
                  <li><span className="font-bold uppercase">Prezzo: </span>{ currencyFormatter.format(this.props.boardgame.price, { code: 'EUR' }) }</li>
                </ul>
                <div className="sg-boardgame-page__description relative mt-4">
                  <ReactMarkdown source={this.props.boardgame.description} />
                </div>
                <div className="flex justify-center">
                  <a href={`mailto:replay@smart-gaming.it?subject=[Richiesta informazioni] ${this.props.boardgame.title}`}
                     className="appearance-none w-full md:w-1/3 focus:outline-none focus:shadow border border-gray-600 bg-gray-600 text-white hover:bg-white hover:text-gray-600 flex justify-center items-center rounded-full px-12 py-2 mt-3 md:mt-0">
                    <MdMailOutline className="mr-2" /> Richiedi informazioni
                  </a>
                </div>
              </main>
            </Page>
        }
      </React.Fragment>
    );
  }
}

export default SecondHandBoardgamePage;